var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95 10.95L12.2375 5.6625L11.1875 4.6125L6.95 8.85L4.8125 6.7125L3.7625 7.7625L6.95 10.95ZM8 15C6.9625 15 5.9875 14.8031 5.075 14.4094C4.1625 14.0156 3.36875 13.4813 2.69375 12.8063C2.01875 12.1313 1.48438 11.3375 1.09063 10.425C0.696875 9.5125 0.5 8.5375 0.5 7.5C0.5 6.4625 0.696875 5.4875 1.09063 4.575C1.48438 3.6625 2.01875 2.86875 2.69375 2.19375C3.36875 1.51875 4.1625 0.984375 5.075 0.590625C5.9875 0.196875 6.9625 0 8 0C9.0375 0 10.0125 0.196875 10.925 0.590625C11.8375 0.984375 12.6313 1.51875 13.3063 2.19375C13.9813 2.86875 14.5156 3.6625 14.9094 4.575C15.3031 5.4875 15.5 6.4625 15.5 7.5C15.5 8.5375 15.3031 9.5125 14.9094 10.425C14.5156 11.3375 13.9813 12.1313 13.3063 12.8063C12.6313 13.4813 11.8375 14.0156 10.925 14.4094C10.0125 14.8031 9.0375 15 8 15ZM8 13.5C9.675 13.5 11.0938 12.9188 12.2563 11.7563C13.4188 10.5938 14 9.175 14 7.5C14 5.825 13.4188 4.40625 12.2563 3.24375C11.0938 2.08125 9.675 1.5 8 1.5C6.325 1.5 4.90625 2.08125 3.74375 3.24375C2.58125 4.40625 2 5.825 2 7.5C2 9.175 2.58125 10.5938 3.74375 11.7563C4.90625 12.9188 6.325 13.5 8 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/CircleTick.8e7dc99ee9d982e559a97eeca70936f4.svg";
export { ForwardRef as ReactComponent };